import React, { type ReactNode } from 'react';
import { BreadcrumbContainer } from '../controller/index.tsx';

export type ManagerProps = {
	children: ReactNode;
};

export const BreadcrumbManager = ({ children }: ManagerProps) => (
	<BreadcrumbContainer>{children}</BreadcrumbContainer>
);
